import { ShieldAlert } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Label } from "@/components/ui/label";

export default function NoShowPenaltyPicker({ value, onChange }) {
  const { lang } = useLang();
  const IT = lang === "it";
  const primary = [
    { key: "full", label: IT ? "100% del totale" : "100% of total", desc: IT ? "Massima protezione contro no-show" : "Maximum no-show protection" },
    { key: "30_percent", label: IT ? "30% del totale" : "30% of total", desc: IT ? "Bilanciato — più competitivo di Booking" : "Balanced — more competitive than Booking" },
    { key: "first_night", label: IT ? "Solo prima notte" : "First night only", desc: IT ? "Politica soft, aumenta conversione" : "Soft policy, boosts conversion" },
  ];
  const freeOpts = [
    { key: "free_5d", label: IT ? "5 giorni prima" : "5 days before", desc: IT ? "Più restrittiva — meno cancellazioni tardive" : "Stricter — fewer late cancellations" },
    { key: "free_3d", label: IT ? "3 giorni prima" : "3 days before", desc: IT ? "Bilanciata — standard di mercato" : "Balanced — market standard" },
    { key: "free_1d", label: IT ? "1 giorno prima" : "1 day before", desc: IT ? "Molto flessibile — massima conversione" : "Very flexible — highest conversion" },
  ];
  const isFree = (value || "").startsWith("free_");
  return (
    <div className="border border-border rounded-lg p-5 bg-card" data-testid="no-show-penalty-picker">
      <div className="flex items-center gap-2 mb-1">
        <ShieldAlert className="w-4 h-4 text-primary"/>
        <Label className="mb-0">{IT ? "Politica no-show (Pay at Property)" : "No-show policy (Pay at Property)"}</Label>
      </div>
      <p className="text-xs text-muted-foreground mb-4 leading-relaxed">
        {IT
          ? "Quando un ospite prenota con carta a garanzia e non si presenta, viene addebitato questo importo. Applicato alle prenotazioni future — le prenotazioni già confermate mantengono la politica del momento della prenotazione."
          : "When a guest books with a card guarantee and does not show up, this amount is charged. Applied to future bookings — already-confirmed bookings keep the policy from booking time."}
      </p>
      <div className="grid sm:grid-cols-3 gap-2">
        {primary.map((o) => (
          <button
            key={o.key} type="button"
            onClick={() => value !== o.key && onChange(o.key)}
            data-testid={`no-show-opt-${o.key}`}
            className={`text-left border rounded-md p-3 transition-all lift ${value === o.key ? "border-primary bg-primary/5 ring-1 ring-primary/30" : "border-border bg-background hover:border-primary/40"}`}
          >
            <div className="font-semibold text-sm mb-1">{o.label}</div>
            <div className="text-[11px] text-muted-foreground leading-snug">{o.desc}</div>
          </button>
        ))}
      </div>
      <div className={`mt-3 border rounded-md p-3 transition-all ${isFree ? "border-primary bg-primary/5" : "border-border bg-background"}`} data-testid="free-cancel-group">
        <div className="text-[11px] uppercase tracking-[0.2em] text-sage font-semibold mb-2">
          {IT ? "Oppure — Cancellazione gratuita fino a…" : "Or — Free cancellation until…"}
        </div>
        <p className="text-[11px] text-muted-foreground mb-3 leading-snug">
          {IT
            ? "L'ospite può cancellare senza penale entro questo periodo. Oltre la finestra si applica il 100% come penale no-show."
            : "The guest can cancel free of charge within this window. After it, the standard 100% no-show penalty applies."}
        </p>
        <div className="grid sm:grid-cols-3 gap-2">
          {freeOpts.map((o) => (
            <button
              key={o.key} type="button"
              onClick={() => value !== o.key && onChange(o.key)}
              data-testid={`no-show-opt-${o.key}`}
              className={`text-left border rounded-md p-3 transition-all lift ${value === o.key ? "border-primary bg-primary/5 ring-1 ring-primary/30" : "border-border bg-background hover:border-primary/40"}`}
            >
              <div className="font-semibold text-sm mb-1">{o.label}</div>
              <div className="text-[11px] text-muted-foreground leading-snug">{o.desc}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
